var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttendees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.5455L13.9 2V11.4545H23L11.1 26V16.5455H2Z",
    fill: "url(#paint0_linear_161_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.5455L13.9 2V11.4545H23L11.1 26V16.5455H2Z",
    stroke: "#14B4C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_14",
    x1: 12.5,
    y1: 2,
    x2: 12.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B4C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttendees);
export default __webpack_public_path__ + "static/media/icon-attendees.081bed78947891abb5afde06766ebabc.svg";
export { ForwardRef as ReactComponent };